<template>
  <div>
    <el-header>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>发票管理</el-breadcrumb-item>
        <el-breadcrumb-item>抬头管理</el-breadcrumb-item>
        <el-breadcrumb-item>新增抬头</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <el-form
      style="background: #fff"
      ref="form"
      size="small"
      label-position="top"
      :model="formModel"
      class="demo-ruleForm"
    >
      <div
        style="
          line-height: 40px;
          text-indent: 20px;
          border-bottom: 1px solid #eee;
          font-weight: 700;
        "
      >
        发票抬头信息
      </div>
      <el-row :gutter="24" style="padding: 20px">
        <el-col :span="12">
          <el-form-item
            label="企业名称"
            prop="enterpriseName"
            :rules="[{ required: true, message: '请输入', trigger: 'blur' }]"
          >
            <el-input v-model="formModel.enterpriseName" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="纳税人识别码"
            prop="taxPayerCode"
            :rules="[{ required: true, message: '请输入', trigger: 'blur' }]"
          >
            <el-input v-model="formModel.taxPayerCode" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="开户行"
            prop="bankName"
            :rules="[{ required: true, message: '请输入', trigger: 'blur' }]"
          >
            <el-input v-model="formModel.bankName" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="开户行账号"
            prop="bankCode"
            :rules="[{ required: true, message: '请输入', trigger: 'blur' }]"
          >
            <el-input v-model="formModel.bankCode" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="电话"
            prop="enterpriseTelephone"
            :rules="[{ required: true, message: '请输入', trigger: 'blur' }]"
          >
            <el-input
              v-model="formModel.enterpriseTelephone"
              placeholder="请输入"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            label="地址"
            prop="enterpriseRegAddr"
            :rules="[{ required: true, message: '请选择', trigger: 'blur' }]"
          >
            <el-input
              v-model="formModel.enterpriseRegAddr"
              placeholder="请输入"
            />
            <!-- <addressPage
              :etpRegAddress="etpRA"
              @addr-sent="initAddr"
            ></addressPage> -->
          </el-form-item>
        </el-col>
      </el-row>
      <div
        style="
          line-height: 40px;
          text-indent: 20px;
          border-bottom: 1px solid #eee;
          font-weight: 700;
        "
      >
        其他信息
      </div>
      <el-row :gutter="24" style="padding: 20px">
        <el-col :span="12">
          <el-form-item
            label="联系人姓名"
            prop="applicant"
            :rules="[{ required: true, message: '请输入', trigger: 'blur' }]"
          >
            <el-input v-model="formModel.applicant" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="联系人手机号"
            prop="telephone"
            :rules="[{ required: true, message: '请输入', trigger: 'blur' }]"
          >
            <el-input
              maxlength="11"
              v-model="formModel.telephone"
              placeholder="请输入"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="电子邮箱"
            prop="mailbox"
            :rules="[{ required: true, message: '请输入', trigger: 'blur' }]"
          >
            <el-input v-model="formModel.mailbox" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="24">
          <el-form-item
            label="联系地址"
            prop="applicantArea"
            :rules="[{ required: true, message: '请选择', trigger: 'blur' }]"
          >
            <addressPage
              :etpRegAddress="etpRA2"
              @addr-sent="initAddr2"
            ></addressPage>
          </el-form-item>
        </el-col> -->
      </el-row>
      <div style="padding-bottom: 20px; text-align: center">
        <el-button
          style="margin-right: 50px; width: 200px"
          size="medium"
          @click="resetForm('form')"
          >取 消</el-button
        >
        <el-button
          size="medium"
          style="width: 200px"
          type="primary"
          @click="submitForm('form')"
          >提 交</el-button
        >
      </div>
    </el-form>
  </div>
</template>
<script>
import addressPage from '@/components/MainData/mainDataAddr.vue'
import {
  getAddTitle,
  getTitleUpdate,
  getTitleDetail
} from '@/api/adminData/index'
export default {
  components: { addressPage },
  data() {
    return {
      contentLoading: false,
      formModel: {
        guid: '', // 发票抬头id
        enterpriseName: '', // 企业名称
        taxPayerCode: '', // 纳税人识别码
        bankName: '', // 开户行
        bankCode: '', // 开户行账号
        enterpriseTelephone: '', // 注册电话
        applicant: '', // 联系人姓名
        telephone: '', // 联系人手机
        mailbox: '', // 联系人邮箱
        // 注册地址
        enterpriseRegProvince: '', // 省
        enterpriseRegCity: '', // 市
        enterpriseRegArea: '', // 区县
        enterpriseRegStreet: '', // 街道
        enterpriseRegAddr: '' // 详细地址
        // 收票地址
        // applicantProvince: '', // 省
        // applicantCity: '', // 市
        // applicantArea: '', // 区县
        // applicantStreet: '', // 街道
        // applicantAddr: '' // 详细地址
      },
      etpRA: {
        province: '',
        city: '',
        area: '',
        addr: '',
        street: ''
      }
      // etpRA2: {
      //   province: '',
      //   city: '',
      //   area: '',
      //   addr: '',
      //   street: ''
      // } // 注册地址
    }
  },
  mounted() {
    this.formModel.guid = this.$route.query.guid || ''
    if (this.formModel.guid) {
      this.getDetailData()
    }
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.go(-1)
    },
    submitForm(formName) {
      // 提交
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.contentLoading = true
          let api = ''
          if (this.formModel.guid) {
            // 更新
            api = getTitleUpdate
          } else {
            // 添加
            api = getAddTitle
          }
          api(this.formModel).then((res) => {
            if (res.success) {
              this.$message.success(res.message)
              this.$router.go(-1)
            }
            this.contentLoading = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getDetailData() {
      // 详情
      getTitleDetail({
        guid: this.formModel.guid
      }).then((res) => {
        if (res.success) {
          this.formModel = res.result
          // this.etpRA = {
          //   province: this.formModel.enterpriseRegProvince,
          //   city: this.formModel.enterpriseRegCity,
          //   area: this.formModel.enterpriseRegArea,
          //   street: this.formModel.enterpriseRegStreet,
          //   addr: this.formModel.enterpriseRegAddr
          // }
          // this.etpRA2 = {
          //   province: this.formModel.applicantProvince,
          //   city: this.formModel.applicantCity,
          //   area: this.formModel.applicantArea,
          //   street: this.formModel.applicantStreet,
          //   addr: this.formModel.applicantAddr
          // }
        }
        this.contentLoading = false
      })
    }
    // initAddr(originAddr) {
    //   // 注册地址
    //   this.formModel.enterpriseRegProvince = originAddr.province
    //   this.formModel.enterpriseRegCity = originAddr.city
    //   this.formModel.enterpriseRegArea = originAddr.area
    //   this.formModel.enterpriseRegStreet = originAddr.street
    //   this.formModel.enterpriseRegAddr = originAddr.addr
    // }
    // initAddr2(originAddr) {
    //   // 收票地址
    //   this.formModel.applicantProvince = originAddr.province
    //   this.formModel.applicantCity = originAddr.city
    //   this.formModel.applicantArea = originAddr.area
    //   this.formModel.applicantStreet = originAddr.street
    //   this.formModel.applicantAddr = originAddr.addr
    // }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form--label-top .el-form-item__label {
  float: none;
  display: inline-block;
  text-align: left;
  padding: 0 0 0 0;
}
</style>
